(() => {
  const selectDefaultPack = (root = document) => {
    root.querySelectorAll('variant-selects[data-default-pack]').forEach((variantSelects) => {
      if (variantSelects.dataset.defaultPackApplied === 'true') return;
      variantSelects.dataset.defaultPackApplied = 'true';

      const requestedPack = variantSelects.dataset.defaultPack.trim();
      if (!requestedPack) return;

      const option = Array.from(variantSelects.querySelectorAll('input[type="radio"][data-option-name]')).find(
        (input) => input.dataset.optionName && input.value === requestedPack
      );

      if (option && !option.checked) {
        variantSelects.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = radio === option;
        });

        if (!option.disabled) {
          option.click();
        } else {
          option.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (option.dataset.variantId) {
          const productInfo = variantSelects.closest('product-info');
          productInfo?.querySelectorAll('input.product-variant-id').forEach((input) => {
            input.value = option.dataset.variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          try {
            const variant = JSON.parse(option.dataset.variantJson);
            const selectedVariant = variantSelects.querySelector('[data-selected-variant]');
            if (selectedVariant) selectedVariant.textContent = JSON.stringify(variant);
          } catch {
            // Keep Dawn's selected variant data if the optional JSON payload is unavailable.
          }

          const price = document.getElementById(`price-${variantSelects.dataset.section}`);
          price?.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach((priceItem) => {
            priceItem.textContent = option.dataset.displayPrice;
          });
          // Precio tachado del pack elegido (solo si la tarjeta lo trae).
          const compare = price?.querySelector('.price__sale .price-item--regular');
          if (compare && option.dataset.displayCompare) compare.textContent = option.dataset.displayCompare;
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => selectDefaultPack(), { once: true });
  } else {
    selectDefaultPack();
  }

  document.addEventListener('shopify:section:load', (event) => selectDefaultPack(event.target));
})();
